import { render, staticRenderFns } from "./FooterSocials.vue?vue&type=template&id=48476c07&scoped=true&"
import script from "./FooterSocials.vue?vue&type=script&lang=js&"
export * from "./FooterSocials.vue?vue&type=script&lang=js&"
import style0 from "./FooterSocials.vue?vue&type=style&index=0&id=48476c07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48476c07",
  null
  
)

export default component.exports